/** @jsxRuntime classic */
/** @jsx jsx */

import React, { FC } from 'react';
import { css, jsx } from '@emotion/react';
import { ISlot } from './types';
import { ECalendarMode } from './index';

export interface IEventComponentProps {
	event: ISlot;
	inList?: boolean;
	mode?: ECalendarMode;
	currentDate?: string;
	horizontal?: boolean;
}

const modalSlotContainerCss = css`
	position: relative;
	margin: 2px;
	height: 70px;
`;

interface IProps {
	slot: ISlot;
	SlotWrapper: FC<IEventComponentProps>;
	mode?: ECalendarMode;
	currentDate?: string;
	horizontal?: boolean;
}

export const SlotInModal = ({ slot, SlotWrapper, horizontal, mode, currentDate }: IProps) => {
	return (
		<div css={modalSlotContainerCss} data-aid="SlotInModal-bo_calendar_slot">
			<SlotWrapper event={slot} inList mode={mode} currentDate={currentDate} horizontal={horizontal} />
		</div>
	);
};
